import type { i18n } from "i18next";

const LABEL_KEYS = new Map([
  ["Organic", "common.applicationSourceTypes.organic"],
  ["Sponsored", "common.applicationSourceTypes.sponsored"],
  ["CV Database", "common.applicationSourceTypes.cvDatabase"],
  ["Unknown", "common.applicationSourceTypes.unknown"],
  ["Not available", "common.applicationSourceTypes.notAvailable"],
]);

export function translateApplicationSourceType(value: string, t: i18n["t"]): string {
  const key = LABEL_KEYS.get(value);
  return key ? t(key) : value;
}

export function formatApplicationSourceTypes(
  types: string[] | undefined,
  t: i18n["t"],
): string | undefined {
  if (!types?.length) return undefined;
  return types.map((type) => translateApplicationSourceType(type, t)).join(", ");
}
